import type React from "react";

interface Props {
  size?: number;
  color?: string;
}

export function LeftHalfIcon(props: Props): React.ReactNode {
  const { size = 24, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title>Left Half</title>
      <path
        d="M21.25 11.6644C21.25 16.485 17.2114 20.4357 12.189 20.5326V2.79626C17.2114 2.89317 21.25 6.84387 21.25 11.6644Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinejoin="bevel"
      />
      <path
        d="M11.939 2.54443C6.72897 2.57604 2.5 6.6553 2.5 11.6643C2.5 16.6732 6.72897 20.7525 11.939 20.7841V2.54443Z"
        fill="currentColor"
      />
    </svg>
  );
}
